import React from 'react';
import intl from 'react-intl-universal';

class FooterComponent extends React.Component {
  constructor(){
    super();
    this.onSelectLocale = this.onSelectLocale.bind(this);
  }

  renderLocaleSelector() {
    let current = intl.options.currentLocale || ''
    return (
      <select className="lang" onChange={this.onSelectLocale} defaultValue={current}>
        <option value="" disabled>Język</option>
        {this.props.locales.map(locale => (
          <option key={locale.value} value={locale.value}>{locale.name}</option>
        ))}
      </select>
    );
  }

  onSelectLocale(e) {
    let lang = e.target.value;
    location.search = `?lang=${lang}`;
  }

  render() {
    return (
      <footer>
        <p className="copyright">© Copyright 2019  <a href="https://www.ideacommercesolutions.pl" target="_blank">IDEA commerce solutions</a> {intl.get('Wszelkie prawa zastrzeżone.')}</p>
        {this.renderLocaleSelector()}
        <p className="pull-right">Powered by <a href="https://www.ideaerp.pl/" target="_blank">IDEAerp</a>.</p>
      </footer>
    );
  }
}

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/Footer.js